var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-tile',{attrs:{"amount":_vm.number(_vm.item.amount),"extraModifiers":_vm.classnameModifiers,"name":_vm.item.display_name,"previous-amount":_vm.number(_vm.item.previous_amount),"type":_vm.item.type}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe40547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/ProductDashboardItem.vue
// module id = B2iE
// module chunks = 1